import {
  FaCheckCircle,
  FaClipboard,
  FaInfinity,
  FaKeyboard,
  FaNewspaper,
  FaTasks,
} from "@onemind-services-llc/react-icons-ng/fa";

export const GNS3_FEATURES_LIST = [
  "On-demand proof of concept and certification labs",
  "Custom environment setup by our experts",
  "High-quality infrastructure on Cisco UCS servers",
  "Commitment to providing cost-effective solutions for the IT community.",
];

export const GNS3_REASON = {
  desc: [
    "GNS3 (Graphical Network Simulator-3) is a powerful network emulation software that allows IT professionals, students, and networking enthusiasts to design, configure, and test complex network topologies in a virtual environment. With GNS3, users can create realistic network scenarios using a wide range of virtual devices, such as routers, switches, and firewalls, from popular vendors like Cisco, Juniper, and Fortinet.",
    "GNS3 provides a user-friendly graphical interface that enables users to drag and drop devices, connect them with virtual cables, and configure their settings as if they were working with physical hardware. This allows users to experiment with different network designs, practice configurations, and troubleshoot issues without the need for expensive physical equipment.",
  ],
  Points: [
    "Support for a wide range of vendor devices and operating systems",
    "Integration with virtualization platforms like VMware and VirtualBox",
    "Ability to connect virtual networks to physical networks",
    "Snapshot and backup functionality for saving and restoring network states",
    "Collaboration features for sharing projects and working with team members",
  ],
};

export const WhyGNS3List = [
  {
    title: "Cost-Effective Learning and Experimentation",
    desc: "CloudMyLab's hosted GNS3 service allows network professionals to create virtual labs and experiment with various network configurations without investing in expensive physical hardware.",
  },
  {
    title: "Flexibility and Accessibility",
    desc: "With CloudMyLab's GNS3 service, network professionals can access their virtual labs from anywhere, at any time, using a web browser. This flexibility allows users to work on their projects remotely, collaborating with team members and adapting to changing project requirements easily.",
  },
  {
    title: "Realistic Network Emulation",
    desc: "GNS3 on CloudMyLab provides a realistic emulation environment that closely mimics real-world network scenarios. Network professionals can create complex topologies, test configurations, and troubleshoot issues in a safe, isolated environment without impacting live networks.",
  },
  {
    title: "Vendor-Neutral Platform",
    desc: "CloudMyLab's GNS3 service supports a wide range of vendor devices and operating systems, allowing network professionals to gain experience with different technologies and platforms. This vendor-neutral approach helps users develop a comprehensive understanding of networking concepts and enhances their marketability in the industry.",
  },
  {
    title: "Scalability and Resource Optimization",
    desc: "CloudMyLab's GNS3 service offers scalable resources, enabling network professionals to create labs that suit their specific needs. Users can easily adjust the allocated resources, such as RAM and CPU, to optimize performance and cost-effectiveness.",
  },
  {
    title: "Professional Development and Certification Preparation",
    desc: "GNS3 on CloudMyLab provides an ideal platform for network professionals to prepare for industry certifications, such as Cisco CCNA, CCNP, or CompTIA Network+. Users can create custom labs that focus on specific exam objectives, allowing them to practice and reinforce their knowledge in a hands-on environment.",
  },
];

export const GNS3_PRICING_TYPES = [
  {
    title: "Cloud Instances",
    items: [
      { subtitle: "Flexible & Scalable" },

      {
        subtitle: "Monthly Freedom",
        desc: "Ideal for short-term projects, offering the agility to scale up or down as needed.",
      },

      {
        subtitle: "Annual Advantage",
        desc: "Save 15% with annual billing, perfect for ongoing or larger scale projects.",
      },
    ],
  },
  {
    title: "Baremetal ",
    items: [
      { subtitle: "Dedicated & Powerful" },

      {
        subtitle: "Exclusive Control",
        desc: "Choose this for dedicated hardware power, ensuring high performance and reliability.",
      },

      {
        subtitle: "Annual Savings",
        desc: "Benefit from a 15% discount on annual plans, aligning long-term projects with cost efficiency.",
      },
    ],
  },
];

export const GNS3_HOSTED_BACKED_SERVICES_LIST = [
  { icon: FaKeyboard, content: "Robust IT Infrastructure" },
  { icon: FaTasks, content: "Class Apart SLA of 99.1%" },
  { icon: FaInfinity, content: "24 X 7 Support" },
  { icon: FaNewspaper, content: "Free Trials" },
  { icon: FaClipboard, content: "Best Price Guaranteed" },
  { icon: FaCheckCircle, content: "Variable Length Subscription" },
];
